import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetch =  (url) => {

    const [dataCrew, setDataCrew] = useState(null);
    const [dataDestination, setDataDestination] = useState(null);
    const [dataTech, setDataTech] = useState(null);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(url);
                const resData = response.data;
                setDataCrew(resData.crew);
                setDataDestination(resData.destinations);
                setDataTech(resData.technology);
        }
        catch (err) {
                setError(err);
                setDataCrew(null);
                setDataDestination(null);
                setDataTech(null);
        }
        }
        fetchData()
    },[url])

    return {dataCrew,dataDestination,dataTech,error}
}
 
export default useFetch;